(function () {
    "use strict";

    angular.module("app").controller("UsersController", UsersController);

    UsersController.$inject = ["infiniteScrollDataSourceFactory", "controllerDecorator"
    ];
    function UsersController(infiniteScrollDataSourceFactory, controllerDecorator) {
        const vm = Object.assign(this, {
            OpenDetailInBootbox,
            SetBackgroundByUser,
            OpenPersonDossier,
            SearchByRoleAndClearance,
            GetOrganisationDossierInfo
        });
        controllerDecorator.Decorate(vm, ["navigation", "dialog"]);

        vm.SetLoadingState(false);

        initialize();

        function OpenDetailInBootbox(user) {
            vm.User = user;

            const urlToLoad = `${vm.Settings.GetBaseUrl()}Administration/UserDetail/${user.UserName}`;

            const options = {
                onEscape: true,
                closeButton: true,
                size: "large",
                title: "",
                templateUrl: urlToLoad
            };
            vm.Dialog.Custom(options);
        }

        function SetBackgroundByUser(user) {
            if (!user || !user.ClearanceExpirationDate || user.Roles.length < 1) return;

            if (habilCommon.dateUtils.isExpired(user.ClearanceExpirationDate))
                return "overview-expired";

            const userRoles = user.Roles;

            const hasVORoles = userRoles.some((userRole) => userRole === "VO-SO" || userRole === "VO-ASO");

            if (hasVORoles) {
                if (habilCommon.dateUtils.isExpiring(user.ClearanceExpirationDate, 1))
                    return "overview-expiring";
                else
                    return "overview-valid";
            }

            const hasUserRole = userRoles.some((userRole) => userRole === "USER");
            if (hasUserRole) {
                return "InvolvedValidClearance";
            }
            return null;
        }

        function OpenPersonDossier(id) {
            if (!id) return;
            vm.Navigator.OpenDossierPerson(id);
        }

        function SearchByRoleAndClearance(colorFilter) {
            if (!vm.DataSource)
                return;

            const filter = vm.DataSource.GetFilter();
            if (!filter)
                return;
            if (!colorFilter || filter.RoleAndClearance === colorFilter) {
                delete filter.RoleAndClearance;
            }
            else {
                filter.RoleAndClearance = colorFilter;
            }

            vm.DataSource.ResetSearch();
        }

        function GetOrganisationDossierInfo(organisationDossier, hideICD = false) {
            if (!organisationDossier) {
                return "";
            }

            return `${organisationDossier.ReferenceNumber} : ${organisationDossier.Name} [${organisationDossier.DossierNumber}${hideICD || !organisationDossier.ICD ? "" : ` - ${organisationDossier.ICD}`}]`;
        }

        function initialize() {
            vm.DataSource = infiniteScrollDataSourceFactory.Create(vm.Api.GetUsersByRolePaged, (v) => vm.isLoadingRequests = v);

            const pageAndSort = vm.DataSource.GetPageAndSort();

            if (pageAndSort.SortBy.length > 0) {
                vm.sortType = pageAndSort.SortBy[0].Name;
                vm.sortReverse = pageAndSort.SortBy[0].IsReverse;
            }
            else {
                vm.sortType = "Name";
                vm.sortReverse = false;
            }
        }
    }
})();